import { DocumentTableRow } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns'

export interface BaseSearchableItem {
  id: string
  itemType: string
  displayName: string
  description?: string
  timestamp?: string
}

export interface DocumentSearchItem extends BaseSearchableItem {
  itemType: 'document'
  documentData: DocumentTableRow
}

export interface SensorSearchItem extends BaseSearchableItem {
  itemType: 'sensor'
  sensorId: string
  unit?: string
  asset?: string
  name: string
}

export interface AssetSearchItem extends BaseSearchableItem {
  itemType: 'asset'
  name: string
  assetType?: string
  hasLinkedDatapoints: boolean
  linkedDatapointIds: string[]
  linkedDocumentIds: string[]
  linkedDocumentCount: number
}

export interface ChartSearchItem extends BaseSearchableItem {
  itemType: 'chart'
  name: string
  /** Sensor ids the saved chart plots; used to seed a timeseries tab. */
  sensorIds: string[]
}

export type SearchableItem =
  | DocumentSearchItem
  | SensorSearchItem
  | AssetSearchItem
  | ChartSearchItem

export interface RecentItem<T extends SearchableItem = SearchableItem> {
  item: T
  accessedAt: string
}

export function isDocumentSearchItem(
  item: SearchableItem
): item is DocumentSearchItem {
  return item.itemType === 'document'
}

export function isSensorSearchItem(
  item: SearchableItem
): item is SensorSearchItem {
  return item.itemType === 'sensor'
}

export function isAssetSearchItem(
  item: SearchableItem
): item is AssetSearchItem {
  return item.itemType === 'asset'
}

export function isChartSearchItem(
  item: SearchableItem
): item is ChartSearchItem {
  return item.itemType === 'chart'
}

export function documentTableRowToSearchItem(
  row: DocumentTableRow
): DocumentSearchItem {
  return {
    id: row.id,
    itemType: 'document',
    displayName: row.title,
    description: row.documentTitle ?? undefined,
    timestamp: row.timestamp ?? undefined,
    documentData: row,
  }
}

export function searchItemToDocumentTableRow(
  item: DocumentSearchItem
): DocumentTableRow {
  return item.documentData
}
